import { apiRequest } from "./ApiUtility";

// export async function getEnquiryComments(authContext, enquiryId) {
//   const url = `/api/enquiry/comment/create/${documentType}/${documentId}`;
//   return await apiRequest("get", url, authContext);
// }
export async function addEnquiryComment(authContext, comment) {
  const url = `/api/enquiry/comment/create`;
  return await apiRequest("post", url, authContext, comment);
}
export async function updateDocumentNote(authContext, note) {
  const url = `/api/documentnote`;
  return await apiRequest("put", url, authContext, note);
}
export async function deleteDocumentNote(authContext, noteId) {
  const url = `/api/documentnote/${noteId}`;
  return await apiRequest("delete", url, authContext);
}